<script setup lang="ts">
import BuildingMultiple24Regular from '@vicons/fluent/es/BuildingMultiple24Regular'
import CheckmarkCircle24Regular from '@vicons/fluent/es/CheckmarkCircle24Regular'
import MailInbox24Regular from '@vicons/fluent/es/MailInbox24Regular'
import People24Regular from '@vicons/fluent/es/People24Regular'
import Warning24Regular from '@vicons/fluent/es/Warning24Regular'
import { computed } from 'vue'
const props = defineProps<{ title: string; description?: string; icon?: string }>()
const glyph = computed(() =>
  props.icon === '🏠'
    ? BuildingMultiple24Regular
    : props.icon === '👥'
      ? People24Regular
      : props.icon === '✅'
        ? CheckmarkCircle24Regular
        : props.icon?.includes('⚠')
          ? Warning24Regular
          : MailInbox24Regular,
)
</script>
<template>
  <n-empty class="apmp-empty" :description="title">
    <template #icon><n-icon :component="glyph" aria-hidden="true" /></template>
    <template #default><h3 class="apmp-empty__title text-base font-medium m-0">{{ title }}</h3></template>
    <template #extra>
      <p v-if="description" class="apmp-muted text-sm m-0 max-w-md">{{ description }}</p>
      <div v-if="$slots.action" class="mt-3"><slot name="action" /></div>
    </template>
  </n-empty>
</template>
<style scoped>
.apmp-empty__title { color: var(--apmp-text); }
.apmp-empty { padding: 40px 16px; text-align: center; }
</style>
